export default __webpack_public_path__ + "static/media/sounds/TRO_Practice_Reading.mp3";